import type { MouseEvent } from 'react';
import type { AnalyticsEvent } from 'src/common/interfaces/segment';
import type { Notification } from './notifications.types';

export function categorizeNotifications(notificationsToCategorize?: Notification[]) {
  const specialUserNotifications: Notification[] = [];
  const userNotifications: Notification[] = [];

  if (notificationsToCategorize) {
    for (const notification of notificationsToCategorize) {
      if (notification?.isSpecial) specialUserNotifications.push(notification);
      if (notification && !notification.isSpecial) userNotifications.push(notification);
    }
  }

  return { specialUserNotifications, userNotifications };
}

type TrackedNotification = Notification & {
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onView?: () => void;
};

export function addTrackingToNotifications(
  notifications: Notification[],
  trackEvent: (event: AnalyticsEvent) => void,
): TrackedNotification[] {
  return notifications.map<TrackedNotification>((notification) => {
    const { groupId } = notification;
    return {
      ...notification,
      onClick: (e: MouseEvent<HTMLDivElement>) => {
        const anchor = (e.target as HTMLElement).closest('a');
        if (!anchor) return;
        trackEvent({
          event: 'click-notification-link',
          properties: { 'group-id': groupId },
        });
      },
      onView: () => {
        trackEvent({
          event: 'view-notification',
          properties: { 'group-id': groupId },
        });
      },
    };
  });
}
